import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['toggleable', 'filterBtn']

  checkOnText(event) {
    let checkbox = $(`#${event.target.dataset.checkboxId}`);
    checkbox.prop('checked', !checkbox.prop('checked'));
  }

  toggleFilters(event) {
    event.preventDefault();

    if (!this.hasToggleableTarget) return

    var sidebar = $(this.toggleableTarget)

    sidebar.toggleClass('hidden')

    if (!this.hasFilterBtnTarget) return

    var filterText = $(this.filterBtnTarget)

    if (sidebar.hasClass('hidden')) {
      filterText.text('Show filters');
    } else {
      filterText.text('Hide filters');
    }
  }

  toggleInsightsFilters(event) {
    event.preventDefault();

    if (!this.hasToggleableTarget) return

    var sidebar = $(this.toggleableTarget)

    sidebar.toggleClass('hidden')

    if (!this.hasFilterBtnTarget) return

    var filterText = $(this.filterBtnTarget)

    if (sidebar.hasClass('hidden')) {
      filterText.text('Show filters');
    } else {
      filterText.text('Hide filters');
    }
  }

  continueAssigning(event) {
    event.preventDefault();

    const returnUrl = localStorage.getItem('addSeatsReturnUrl');
    localStorage.removeItem('addSeatsReturnUrl');

    window.location.href = returnUrl || event.currentTarget.href;
  }
}
